import config from 'config';
import { BRANDS } from 'config/environments/shared';
import { Content } from 'pages';

export const ResellerMagazine = () => {
  const isEud = BRANDS.EUD === config.app.short;
  const pageInfo = {
    document: 'revista_dos_revendedores',
    title: isEud ? 'Guia Mais' : 'Revista do Revendedor',
    description:
      'Para você ficar por dentro dos lançamentos, garantir lucros extras e ter informações que vão impulsionar suas vendas.',
  };

  return <Content {...pageInfo} showHeaderCarrossel={false} />;
};
